var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolicitarVacaciones(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sun-setting-03"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M4.54504 15.6844C5.45254 16.0969 6.60754 16.0969 7.51504 15.6844C8.42254 15.2719 9.57754 15.2719 10.485 15.6844C11.3925 16.0969 12.5475 16.0969 13.455 15.6844M9 2.25V3.75M3 9.75H1.5M4.73559 5.48559L3.67493 4.42493M13.2642 5.48559L14.3248 4.42493M16.5 9.75H15M5.25 9.75C5.25 7.67893 6.92893 6 9 6C11.0711 6 12.75 7.67893 12.75 9.75M1.57507 13.0594C2.48257 12.6469 3.63757 12.6469 4.54507 13.0594C5.45257 13.4719 6.60757 13.4719 7.51507 13.0594C8.42257 12.6469 9.57757 12.6469 10.4851 13.0594C11.3926 13.4719 12.5476 13.4719 13.4551 13.0594C14.3626 12.6469 15.5176 12.6469 16.4251 13.0594",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolicitarVacaciones);
export default __webpack_public_path__ + "static/media/solicitar-vacaciones.aee1bd143a93d9dbef9b13cf7ad443df.svg";
export { ForwardRef as ReactComponent };